<template>
  <kendo-dialog
    ref="removeTenantDtl"
    :modal="true"
    :width="300"
    :title="'Confirm Delete'"
    :visible="myUsername"
  >
    Are you sure that you want to delete 
    <span v-if="tenant">tenant {{tenant.name}}</span>
    <span v-if="!tenant">it</span>?
    <kendo-dialog-action :text="'Yes'" :action="actionMethod"></kendo-dialog-action>
    <kendo-dialog-action :text="'Cancel'" :primary="true"></kendo-dialog-action>
  </kendo-dialog>
</template>
 
<script>
export default {
  props: {
    myUsername: Boolean,
    tenant:Object
  },
  methods: {
    actionMethod() {
      this.$emit("OkMethod", { dataItem: this.item });
    },
    openWindow() {
      this.$refs.removeTenantDtl.kendoWidget().open();
    },
    closeWindow() {
    this.$refs.removeTenantDtl.kendoWidget().close();
    },
  },
  data: function() {
    return {
      item: { ...this.dataItems }
    };
  }
};


</script>
<style lang="scss">
.k-window-actions.k-dialog-actions {
  display: none;
}
.k-window{
  width: 200px;
}

</style>